import { IssueCountryFormutil } from 'components/forms/IssueCountry';
import { LegalResidenceCountryFormutil } from 'components/forms/LegalResidenceCountry';
import { CountryFormutil } from 'components/forms/PersonalInfo/components/Country';
import { TaxCountryFormutil } from 'components/forms/TaxCountry';
import { PostOcrTypes } from 'components/forms/UploadID';
import { IdTypeEnum } from 'types/customer';
import { ProgressFormProps } from 'utils/withProgressForm';

export interface OCRFormutil
    extends CountryFormutil,
        IssueCountryFormutil,
        LegalResidenceCountryFormutil,
        TaxCountryFormutil {
    id_type: IdTypeEnum;
    /** 临时用于存储ocr信息的字段 */
    temporary_ocr: PostOcrTypes;
    /** 是否国籍、居住国、签发国、纳税国四个国家都是中国 */
    temporary_is_four_chn: boolean;
}

export type OCRProps = ProgressFormProps<OCRFormutil>;
